<template>
    <div>
        <div class="seo">
            <seo-title :content="'Netværksmøde d. ' + date.pretty + ' hos VW Amager - Skal du med?'"></seo-title>
            <seo-description content="Kom til netværksmøde ved Volkswagen ErhvervsCenter Amager og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."></seo-description>
            <seo-author content="Deveo ApS"></seo-author>
            <seo-keywords content="VW, VW Amager, VW Erhvervscenter, VW Erhvervsbiler, Volkswagen"></seo-keywords>

            <seo-og-title :content="'Netværksmøde d. ' + date.pretty + ' hos VW Amager - Skal du med?'"></seo-og-title>
            <seo-og-description content="Kom til netværksmøde ved Volkswagen ErhvervsCenter Amager og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."></seo-og-description>
            <seo-og-site-name content="VW Amager Erhvervscenter"></seo-og-site-name>

            <seo-google-name :content="'Netværksmøde d. ' + date.pretty + ' hos VW Amager - Skal du med?'"></seo-google-name>
            <seo-google-description content="Kom til netværksmøde ved Volkswagen ErhvervsCenter Amager og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."></seo-google-description>
            <seo-google-image content=""></seo-google-image>
        </div>
        <intro :buttonText="date.pretty + ' - Tilmeld dig her'"
               bg="/static/images/focus-1.jpg"
               videoId="7bGJbhDr7TM"
        >
            <div slot="title">
                VOLKSWAGEN AMAGER<br>ERHVERVSKLUB
            </div>
            <div slot="subtitle">
                Deltag i Volkswagen ErhvervsCenter Amagers netværksmøde og udvid dit netværk på en uformel måde.
            </div>
        </intro>
        <countdown :deadline="date.formatted"></countdown>
        <boxes intro="Volkswagen ErhvervsCenter Amagers netværksmøde"
               firstText="God stemning & nye bekendtskaber"
               firstPicture="/static/images/focus-1.jpg"
               secondText="Minvolkswagen: Din vej til flådestyring"
               secondPicture="/static/images/focus-2.jpg"
               thirdText="Innovativ bilindretning"
               thirdPicture="/static/images/focus-3.jpg"
        ></boxes>
        <practical-info title="Dette skal du glæde dig til">
            <div slot="text">
                For at give vores kunder ny inspiration og et forum for networking, holder vi for danske håndværkere jævnligt netværksmøder. Her er der mulighed for deltagerne, vores oplægsholdere og os at indgå i tæt dialog og videndele om udfordringer, ny teknologi og de muligheder, der byder sig i fremtiden.
                <br><br>
                Hvert møde har et fagligt fokus, hvor vi får besøg af en ekspert på området. Det kan være finansiering, forsikring, håndværktøj, revision, markedsføring og mange flere. Hold øje med, hvad du kan opleve ved det møde, du ønsker at deltage i.
                <!--<br><br>
                Vi starter tidligt om morgenen, så det ikke går ud over din arbejdstid. Der serveres morgenmad og en velsmagende kop friskbrygget kaffe. Vi glæder os til at se dig.-->
            </div>
            <div slot="address">
                Volkswagen Amager<br>
                Englandsvej 437<br>
                2770 Kastrup
            </div>
            <div slot="datetime">
                Torsdag<br>
                {{ date.pretty }}<br>
                Kl. 11.00 - 14.00
            </div>
            <div slot="partners">
                <a href="https://www.ducatidanmark.dk" target="_blank" rel="noopener nofollow">
                    <img src="/static/images/ducati.png" width="60" />
                </a>
                <a href="https://www.anmeld-haandvaerker.dk/" target="_blank" rel="noopener nofollow">
                    <img src="/static/images/anmeld_haandvaerker.png" width="120" />
                </a>
                <a href="http://www.sortimo.dk/" target="_blank" rel="noopener nofollow">
                    <img src="/static/images/Sortimo.png" width="120"/>
                </a>
                <a href="https://deveo.dk/" target="_blank" rel="noopener nofollow">
                    <img src="/static/images/deveo-logo.png" width="120"/>
                </a>
                <a href="https://www.if.dk" target="_blank" rel="noopener nofollow">
                    <img src="/static/images/if.png" width="60" />
                </a>
                <!--<a href="http://www.rtt.dk/produkter/Bilindretning " target="_blank" rel="noopener nofollow">
                    <img src="/static/images/rtt-logo.jpg" width="60"/>
                </a>-->
                <a href="https://www.volkswagen.dk/da/ny-volkswagen/samlede-losninger.html" target="_blank" rel="noopener" style="margin-right:15px;white-space:nowrap;">
                    <span style="font-family:vw-bold">Volkswagen</span> Finans
                </a>
                <a href="https://www.volkswagen.dk/da/ny-volkswagen/samlede-losninger.html" target="_blank" rel="noopener" style="white-space:nowrap;">
                    <span style="font-family:vw-bold">Volkswagen</span> Forsikring
                </a>
                <a href="https://smartvan.dk/" target="_blank" rel="noopener nofollow">
                    <img src="/static/images/smartvan.png" width="200" style="margin-top:30px;" />
                </a>
                <a href="https://www.soeger.dk/" target="_blank" rel="noopener nofollow">
                    <img src="/static/images/soeger.png" width="150" style="margin-top:30px" />
                </a>
                <a href="https://www.rtt.dk/" target="_blank" rel="noopener nofollow">
                    <img src="/static/images/rtt.png" width="80" style="margin-top:20px;" />
                </a>
            </div>
        </practical-info>
        <promo title="Transporter"
               staticCarId="1"
               buttonLink="https://www.volkswagen-erhvervsbiler.dk/da/modeller/transporter-kassevogn.html#"
               buttonText="Online showroom"
        >
            <div slot="text">
                Transporter med sikkerheds- eller infotainmentpakke uden merpris.
            </div>
        </promo>
        <statement-and-price title="Gå herfra inspireret og med nye bekendtskaber"
                             price="GRATIS"
                             mainEmployeeImage="/static/images/nk.jpg"
                             mainEmployeeName="Nigel Kelly"
                             mainEmployeeTitle="Salgschef"
                             secondaryEmployeeImage="/static/images/na.jpg"
                             secondaryEmployeeName="Nick Andreasen"
                             secondaryEmployeeTitle="Salgsrådgiver Erhverv"
                             thirdEmployeeImage="/static/images/fk.jpg"
                             thirdEmployeeName="Frank Kalman"
                             thirdEmployeeTitle="Servicerådgiver Erhverv"
        >
            <div slot="statement">
                Deltag i vores uformelle netværksmøde, hvor du både bliver inspireret af nye løsninger indenfor teknologi, leasing og meget mere, samtidig med at vi sammen kan løse de problemstillinger du måtte have i din dagligdag.
                <br><br>
                Bilverdenen er i konstant forandring og i årene fremover vil der derfor blive stillet større krav til driftsomkostningerne/TCO af virksomhedens flåde. Du vil få større budgetsikkerhed samt højne kvaliteten af din investering.
                <br><br>
                Om din flåde består af 1 eller 100 biler, står vi altid klar med professionel rådgivning.
                <br><br>
                Vi glæder os til at byde dig velkommen i Volkswagen familien.
            </div>
            <li class="check-mark" slot="benefits">Adgang til arrangement</li>
            <li class="check-mark" slot="benefits">Mad & drikke</li>
            <li class="check-mark" slot="benefits">Networking</li>
        </statement-and-price>
        <registration eventId="ddb054affa69ce60f11597144"
                      eventToken="6e2fa0494e"
                      name="Amager"
        ></registration>
        <contact title="Volkswagen Amager ErhvervsCenter"
                 phone="+45 32 47 90 00"
                 facebookUrl="vwamager"
        ></contact>
    </div>
</template>
<script>
    import Intro from '../../../../../src/components/home-sections/intro'
    import Countdown from '../../../../../src/components/home-sections/countdown'
    import Boxes from '../../../../../src/components/home-sections/boxes'
    import PracticalInfo from '../../../../../src/components/home-sections/practical-info'
    import Promo from '../../../../../src/components/home-sections/promo'
    import statementAndPrice from '../../../../../src/components/home-sections/statement-and-price'
    import Registration from '../../../../../src/components/home-sections/registration'
    import Contact from '../../../../../src/components/home-sections/contact'

    export default {
        name: 'Amager',
        data () {
            return {
                date: {
                    pretty: '12. december 2019',
                    formatted: '2019/12/12 11:00'
                }
            }
        },
        created () {
            window.fbq('trackCustom', 'Amager')
        },
        components: {
            'intro': Intro,
            'countdown': Countdown,
            'boxes': Boxes,
            'practical-info': PracticalInfo,
            'promo': Promo,
            'statement-and-price': statementAndPrice,
            'registration': Registration,
            'contact': Contact
        }
    }
</script>



// WEBPACK FOOTER //
// index.vue?e04187f2